<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';
</script>

<template>
    <PdfViewer title="発注ルール" :api-url=url.api.orderTerms.pdf :printable="false" />
</template>